import z from 'zod';
import { ImageTs } from '../../common';

export type TravelerHomePageHero = z.output<typeof HeroTs>;
export const HeroTs = z.object({
  id: z.number(),
  tagLine: z.string(),
  content: z.string(),
  downloadAppCTA: z.string(),
});

export type RatingCard = z.output<typeof ratingCardTs>;
export const ratingCardTs = z.object({
  id: z.number(),
  title: z.string().optional(),
  rating: z.number(),
  appleRating: z.number(),
  appleRatingLabel: z.string(),
  googleRating: z.number(),
  googleRatingLabel: z.string(),
  trustpilotRating: z.number(),
  trustpilotRatingLabel: z.string(),
  subTitle: z.string().optional().nullable(),
});

export type RetailerCard = z.output<typeof retailerCardTs>;
export const retailerCardTs = z.object({
  id: z.number(),
  title: z.string(),
  content: z.string(),
  cta: z.string(),
  picture: ImageTs
});

export type HowItWorksStep = z.output<typeof howItWorksStepTs>;
export const howItWorksStepTs = z.object({
  id: z.number(),
  content: z.string(),
  title: z.string(),
  backgroundImage: ImageTs.extend({
    id: z.int(), // <int>
    documentId: z.string(),
    formats: z.object({
      large: ImageTs.optional(), // 1000px
      medium: ImageTs.optional(), // 750px
      small: ImageTs.optional(), // 500px
      thumbnail: ImageTs.optional(), // 250px
    }).optional(),
  })
});

export type HowItWorksSection = z.output<typeof howItWorksSectionTs>;
export const howItWorksSectionTs = z.object({
  id: z.number(),
  title: z.string(),
  subTitle: z.string(),
  cta: z.string(),
  steps: howItWorksStepTs.array(),
  intercomArticleLink: z.string()
});

export type WayToBuy = z.output<typeof wayToBuyTs>;
export const wayToBuyTs = z.object({
  id: z.number(),
  title: z.string(),
  message: z.string(),
  cta: z.string(),
  pictures: ImageTs.array()
});

export type RefundRateComponent = z.output<typeof refundRateComponentTs>;
export const refundRateComponentTs = z.object({
  id: z.number(),
  title: z.string(),
  message: z.string(),
  rate: z.number(),
  rateHint: z.string(),
  cta: z.string()
});

//testimonial-slide
export type TestimonialSlide = z.output<typeof testimonialSlideTs>;
export const testimonialSlideTs = z.object({
  id: z.number(),
  avatar: ImageTs.extend({
    id: z.int(), // <int>
    documentId: z.string(),
    formats: z.object({
      large: ImageTs.optional(), // 1000px
      medium: ImageTs.optional(), // 750px
      small: ImageTs.optional(), // 500px
      thumbnail: ImageTs.optional(), // 250px
    }).optional(),
  }),
  content: z.string(),
  name: z.string()
});
export type Testimonial = z.output<typeof testimonialTs>;
export const testimonialTs = z.object({
  id: z.number(),
  cta: z.string(),
  testimonialSlides: testimonialSlideTs.array()
});

// export type Faq = z.output<typeof faqTs>;
// export const faqTs = z.object({
//   id: z.number(),
//   categoryTitle: z.string(),
//   title: z.string(),
//   showMoreCta: z.string(),
//   categoryLabel: z.string(),
//   categoryUID: z.string(),
// });

// export type BlogCard = z.output<typeof blogCardTs>;
// export const blogCardTs = z.object({
//   id: z.number(),
//   title: z.string(),
//   content: z.string(),
//   cta: z.string(),
// });

export type SupportClient = z.output<typeof supportClientTs>;
export const supportClientTs = z.object({
  id: z.number(),
  title: z.string(),
  content: z.string(),
  subTitle: z.string(),
  cta: z.string().nullable(),
  pictures: ImageTs.array()
});

//Support-client-infography-card
export type SupportClientInfographyCard = z.output<typeof supportClientInfographyCardTs>;
export const supportClientInfographyCardTs = z.object({
  id: z.number(),
  title: z.string(),
  content: z.string(),
  byPhone: z.string(),
  byChat: z.string(),
  byEmail: z.string()
});

export type DownloadPopupCard = z.output<typeof DownloadPopupCardTs>;
export const DownloadPopupCardTs = z.object({
  id: z.number(),
  title: z.string(),
  content: z.string(),
  appStoreImage: ImageTs,
  playStoreImage: ImageTs
});

export type TravelerComponent = DownloadPopupCard | SupportClientInfographyCard | TravelerHomePageHero | RatingCard | RetailerCard | HowItWorksSection | WayToBuy | RefundRateComponent | Testimonial | SupportClient | HowItWorksStep;


